import { createContext, useContext } from 'react';
import { ControllableElement } from '@bynder-studio/render-core';
import { PartialComponent } from 'packages/services/componentService';
import { ComponentModalMode } from './ComponentModal/types';

export interface ComponentsContextValue {
    isOpen: boolean;
    openModal: (callback: () => void) => void;
    closeModal: () => void;
    openComponentModal: (
        mode: ComponentModalMode,
        selectedElements: ControllableElement[],
        component?: PartialComponent,
        selectedCollectionId?: number,
    ) => void;
}

export const ComponentsContext = createContext<ComponentsContextValue | undefined>(undefined);

export const useComponentsContext = () => {
    const context = useContext(ComponentsContext);

    if (!context) {
        throw new Error('useComponentsContext must be used within ComponentsProvider');
    }

    return context;
};
